import { Box, styled } from '@mui/material'

export const DashedUploadBox = styled(Box)(({ theme }) => ({
  border: '2px dashed',
  borderColor: theme.palette.primary.main,
  borderRadius: `${theme.shape.borderRadius}px`,
  padding: theme.spacing(2),
  cursor: 'pointer',
  backgroundColor: theme.palette.background.default,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}))
